import React from 'react';
import '../css/LegalPages.css';

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <h1>Privacy Policy</h1>
        <p>Effective Date: February 4, 2026</p>
      </section>

      <section className="legal-section">
        <h2>1. Information We Collect</h2>
        <p>
          BlinkURL collects account details (such as username and email), link metadata, click timestamps, anonymized traffic
          signals, and technical usage data necessary to secure and improve the service.
        </p>
      </section>

      <section className="legal-section">
        <h2>2. How We Use Data</h2>
        <p>
          We process data to provide URL shortening, analytics dashboards, abuse prevention, product reliability, and support.
          We do not sell personal data.
        </p>
      </section>

      <section className="legal-section">
        <h2>3. Analytics and Tracking</h2>
        <p>
          BlinkURL tracks click-level events including timestamp, approximate location, device profile, and referrer source to
          provide performance reporting for link creators.
        </p>
      </section>

      <section className="legal-section">
        <h2>4. Security</h2>
        <p>
          We use industry-standard controls to protect your data. Access to administrative credentials is restricted and monitored.
        </p>
      </section>

      <section className="legal-section">
        <h2>5. Data Retention</h2>
        <p>
          Data is retained only as long as necessary for platform operations, legal obligations, and security auditing.
        </p>
      </section>

      <section className="legal-section">
        <h2>6. Your Rights</h2>
        <p>
          You may request access, correction, or deletion of your account data by contacting support. We respond in accordance
          with applicable laws.
        </p>
      </section>

      <section className="legal-section">
        <h2>7. Contact</h2>
        <p>
          For privacy inquiries, contact: <a href="mailto:privacy@bl-i.us">privacy@bl-i.us</a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPage;
